export enum ChartName {
    DEVICE_BRAND,
    DEVICE_TYPE,
    GENDER,
    AGE_RANGE
}